import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import SliderWithPagination from '../../components/slider-with-pagination';
$(() => {
    RevealWhenVisible.init();
    SliderWithPagination.init();
});
